import React from 'react'
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Logo from '../images/Seeding Brains UI/logo.png'
import { Row, Col } from 'react-bootstrap';
import '../assets/css/style.css';
import Header from './global/Header';
import Footer from './global/Footer';


function innovation() {
  return (
    <>
      <section className='bodys1'>
        <div className='header1'>
          {/* <Navbar bg="blue" expand="lg">
            <Container>
              <Navbar.Brand href="#home"><img src={Logo} className="img-fluid" /></Navbar.Brand>
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="ms-auto">
                  <Nav.Link className='active' href="/BusinessPage">Home</Nav.Link>
                  <Nav.Link href="/Desk">Destination</Nav.Link>
                  <Nav.Link href="#link">About</Nav.Link>

                </Nav>
                <Form className="d-flex">
                  <Form.Control
                    type="search"
                    placeholder="Search"
                    className="me-2"
                    aria-label="Search"
                  />

                </Form>
              </Navbar.Collapse>
            </Container>
          </Navbar> */}
          <Header />
        </div>
        <div className='overlay1'>
          <Container>
            <Row>
              <Col md={7}>
                <div className='mt-4'>
                  <h3 className='title'>INNOVATION AND COMMERCIALISATION</h3>
                  <h4 className='title'>Why get the RSD?</h4>
                  <p>-This RSD aims to give learners a comprehensive understanding of innovation and commercialization.</p>
                  <p>-In today’s competitive landscape it is critical that organisations
                    continually innovate both their product offering and processes to
                    ensure that they remain competitive in the market.Adopting a more commercially driven approach is vital to
                    maximize the Return on Investment (ROD).</p>
                  <p>-In this RSD, learners will look at a number of tools and
                    techniques that organisations use to drive innovation and
                    become more commercial in their approach.O The unit gives students cutting-edge knowledge as well as
                    practical application of the key ways in which organisations
                    become more innovative while remaining commercially driven.</p>
                  <p>-By the end of the RSD, learners will have gained an
                    understanding of how innovation is fostered, harnessed, and
                    managed in organizations.</p>
                  <p>-They will learn the value of innovation and its importance in
                    supporting commercial growth.</p>
                  <p>-They will also acquire knowledge that will enable them to
                    develop a creative and innovative approach that will benefit
                    them throughout their career.</p>
                </div>
              </Col>
              <Col md={5} className="mt-5">

                <div className='price mt-5'>
                  <img src="" className='img-fluid' alt='prize'/>
                   <h3 className='text-center'>Learn Storytelling </h3>
                   <h5 className='text-center'>Zakir Khan</h5>
                   <p> Get 13 lessons in 2 hours</p>
                   <p>Daily guided exercises</p>
                   <p>Access to 50k+ community </p>
                   <p>Regular exert feedback </p>
                   <h3 className='text-center'>$47</h3>
                   <h5 className='text-center'>Offer Expires in <span className="title">11:27:19 </span> </h5>
                   <div className='text-center'>
                   <Button>BUY NOW</Button>
                     </div>
                </div>
              </Col>
            </Row>
           

          </Container>
        </div>
        <Footer />
        {/* <div className='footer py-2 text-right'>
          <div className='container'>
          <a href="#" className="fa fa-facebook me-2"></a>
          <a href="#" className="fa fa-instagram me-2"></a>
          <a href="#" className="fa fa-skype"></a>
          </div>
        </div> */}
      </section>

    </>
  )
}

export default innovation